import BrushCreator from '../../brush/brush_v1'

export default BrushCreator
